import { WidgetCard } from '@/components/common/WidgetCard';
import { StatTile } from '@/components/common/StatTile';
import { useAuth } from '@/contexts/AuthContext';
import { useOrgStats } from '@/features/dashboard/hooks/useDashboard';
import { formatCount } from '@/lib/format';
import { BuildingOffice2Icon } from '@/icons';

/** Organizations KPI — organizations this user may operate as (identity /auth/tenants). */
export function OrganizationsWidget() {
  const { user } = useAuth();
  const { data, isLoading, isError, refetch } = useOrgStats();
  return (
    <WidgetCard title="Organizations" icon={BuildingOffice2Icon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && (
        <StatTile
          label="Available to you"
          value={formatCount(data.total)}
          accent="info"
          sublabel={user?.tenantName ? `Active: ${user.tenantName}` : undefined}
        />
      )}
    </WidgetCard>
  );
}
